<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <game-trend-report-table />
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>
</template>

<script>
import GameTrendReportTable from './GameTrendReportTable.vue'

export default {
  name: 'game-trend-report',
  components: { GameTrendReportTable }
}
</script>



// WEBPACK FOOTER //
// src/views/report/risk/game/GameTrendReport.vue